import type TabViewState from "../store/schema/TabViewState";
import datapoints from "../datapoints";
import setTabIsShown from "./setTabIsShown";
import { wrapFunctionForDatapoint } from "owa-analytics";
import { mutatorAction } from "satcheljs";
import { getTabHandler } from "../utils/TabHandler";
import { getStore } from "../store/tabStore";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";

const defaultExport: (viewState: TabViewState, forceClose?: boolean | undefined) => Promise<void> = wrapFunctionForDatapoint({
    name: "TabViewCloseTab",
    ...datapoints.TabViewCloseTab,
    mailbox: () => getModuleContextMailboxInfo(),
}, async function (viewState: TabViewState, forceClose?: boolean) {
    let canClose = true;
    const handler = getTabHandler(viewState.type);
    if (!forceClose && handler && handler.canClose) {
        canClose = await handler.canClose(viewState);
    }
    
    if (canClose) {
        // Reuse the code in setTabIsShown to activate next tab if necessary
        setTabIsShown(viewState, false /*isShown*/);
        
        const index = getStore().tabs.indexOf(viewState);
        if (index >= 0) {
            spliceTabs(index);
        }
    }
});
export default defaultExport;

/* eslint-disable-next-line owa-custom-rules/require-add-identifier-to-mutator-action-variables -- (https://aka.ms/OWALintWiki)
 * Mutator action variables should end with 'Mutator' so that we can more easily identify potential misuses of it.
 *	> Please add 'Mutator' substring add the end of the mutator action variable name. */
const spliceTabs = mutatorAction("spliceTabs", (index: number) => {
    getStore().tabs.splice(index, 1);
});
